import { saveAs } from "file-saver";
import { Document, Page, pdf, StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import axios from "axios";
import { rootUrl } from "../../Api";
import { toast } from "react-toastify";
import cloudStore from "../../store/CloudStore";
import { format } from "date-fns";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 5,
    padding: 10,
  },
});

const MyDocument = (props) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text>{cloudStore.merchant.name}</Text>
        <Text>{format(new Date(), "MMM d, yyy - HH:mm:ss")}</Text>
      </View>
      {props.views.map((view) => {
        return view == null ? null : <View style={styles.section}>{view}</View>;
      })}
    </Page>
  </Document>
);

const save = (pdf, email) => {
  let bodyFormData = new FormData();
  bodyFormData.set("pdf", pdf);
  bodyFormData.set("email", email);
  axios
    .post(rootUrl + "/nova/pdf_reporting", bodyFormData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then(() => {})
    .catch(() => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
};

const PdfGenerator = async (views, email, download) => {
  const blob = await pdf(<MyDocument views={views} title="My PDF" />).toBlob();
  if (download) {
    saveAs(blob);
  } else {
    save(blob, email);
  }
};

export default PdfGenerator;
